import React, { EventHandler, useEffect } from 'react';

export default function useAddEventListener(
  ref: React.RefObject<HTMLElement>,
  eventType: string,
  handler: EventHandler<any>,
  capture = false,
): void {
  useEffect(() => {
    const element = ref.current;

    if (element && eventType && handler) {
      element.addEventListener(eventType, handler, capture);

      return () => {
        element.removeEventListener(eventType, handler, capture);
      };
    }
  }, [ref, eventType, handler, capture]);
}
